<template>
  <div>
    <div class="form-group">
      <label for="searchProduct">Buscar productos</label>
      <el-select id="searchProduct" name="searchProduct" filterable placeholder="Buscar productos" remote
        :remote-method="onHandleRemoteMethod" v-model="selectedProductFilled" @change="onHandleSelected">
        <el-option v-for="product in filterProductsFilledAttachment" :key="product.id" :label="product.nombre"
          :value="product.id" />
      </el-select>
    </div>
    <h6>Productos seleccionados: <span class="badge badge-dark">{{ itemsSelecteds.length }}</span></h6>
    <div class="item-selected-product-content" v-if="itemsSelecteds.length > 0">
      <div v-for="item in itemsSelecteds" :key="item.id" :label="item.nombre" :value="item.id"
        class="item-selected-product">
        <span>{{ item.nombre }}</span>
        <i class="fa fa-trash ml-1" @click="onHandleTrashSelected(item.id)"></i>
      </div>
    </div>
    <div v-else class="text-gray">
      <p><i class="fa fa-info-circle mr-1"></i>{{ messageInfo }}</p>
    </div>
  </div>
</template>

<script>

// generales
import { mapState, mapMutations } from "vuex";

export default {
  props: {
    onRemoteMethod: {
      type: Function,
      default: () => { },
      required: false
    },
    onSelected: {
      type: Function,
      default: () => { },
      required: false
    },
    onTrashSelected: {
      type: Function,
      default: () => { },
      required: false
    },
    itemsSelecteds: {
      type: Array,
      default: new Array(),
      required: true
    },
    messageInfo: {
      type: String,
      default: "No has seleccionado productos aún, el reporte se generará con todos los productos asignados a la empresa.",
      required: false
    }
  },
  name: "filterProductsFilled",
  components: {},
  data() {
    return {
      selectedProductFilled: null,
    }
  },
  methods: {
    // Mutaciones del modulo de Productos diligenciados (rpq)
    ...mapMutations('productsSearch', [
      'setFilterProductsFilledAttachment'
    ]),
    /**
     * Controlar cambios en el select.
     * 
     * @author Fernando Claros
     */
    async onHandleRemoteMethod(value) {
      if (!value) return false;
      this.onRemoteMethod(value);
    },
    /**
     * Seleccionar y agregar items a la lista.
     * 
     * @author Fernando Claros
     */
    onHandleSelected() {

      if (this.itemsSelecteds.find(x => x.id === this.selectedProductFilled)) {
        this.clearData()
        return;
      }

      const product = this.filterProductsFilledAttachment.find(x => x.id === this.selectedProductFilled)

      this.itemsSelecteds.push(product);
      this.clearData()

      this.onSelected(this.itemsSelecteds)

    },
    clearData() {
      this.selectedProductFilled = null
      this.setFilterProductsFilledAttachment([])
    },
    /**
     * Eliminar el items de la lista.
     * 
     * @param {Integer} idProduct
     * @author Fernando Claros
     */
    onHandleTrashSelected(idProduct) {
      const updateProducts = this.itemsSelecteds.filter(x => x.id !== idProduct)
      this.itemsSelecteds = updateProducts

      this.onTrashSelected(this.itemsSelecteds)
    },
  },
  computed: {
    ...mapState('productsSearch', [
      'filterProductsFilledAttachment'
    ])
  }
}
</script>

<style scoped>

@media (min-width: 0px) and (max-width: 780px) {
  .item-selected-product-content {
    grid-template-columns: 100% !important;
  }
}

.item-selected-product-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: grid;
  -ms-flex-pack: start;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  grid-template-columns: 50% 50%;
}

.item-selected-product {
  width: -webkit-fit-content !important;
  width: -moz-fit-content !important;
  width: fit-content !important;
  background: #e6e5e5;
  padding: 3px 7px;
  margin: 2px;
  border-radius: 8px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  min-width: 99%;
  align-items: center;
}

.item-selected-product span {
  font-size: 10px;
}

.item-selected-product i {
  color: black;
}

.item-selected-product i:hover {
  color: rgb(221, 104, 104);
  cursor: pointer;
}

</style>
